import { Library } from ".."
import whiteLabel from "../whitelabel"
import homeJumbo from "./homeJumbo"
import newsletterBlock from "./newsLetterForm"

const bkw: Library = {
  ...whiteLabel,
  homeJumbo,
  newsletterBlock,
  features: {
    autoHyphenate: false,
    manualHyphenate: false
  }
}

export default bkw